<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <router-link class="col04" to="/Invoice">发票管理<span class="plr5">/</span></router-link>
            <router-link class="col04" to="/InvoiceGoods">申请开票<span class="plr5">/</span></router-link>
            <!-- <div class="now_page">添加发票抬头</div> -->
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="col04 fs18 fwb">申请开票</div>
                <div class="flex-box flex-center step_box fs18 cold7">
                    <div class="flex-box" :class="step >= 1 ? 'active' : ''">
                        <i class="fs20">1</i>
                        <div>发票信息</div>
                    </div>
                    <div class="flex-box" :class="step >= 2 ? 'active' : ''">
                        <i class="fs20">2</i>
                        <div>开具电子发票</div>
                    </div>
                    <div class="flex-box" :class="step >= 3 ? 'active' : ''">
                        <i class="fs20">3</i>
                        <div>开票完成</div>
                    </div>
                </div>
                <template v-if="step == 1">
                    <template v-if="!showList">
                        <!-- <div class="flex-box flex-between choose_box">
                            <div class="fs18 col90 fwb">添加发票抬头</div>
                            <div class="flex-box cursor to_choose" @click="showList = true">去选择抬头</div>
                        </div> -->
                        <div class="form_box">
                            <div class="flex-box mb25 fs16 col04">
                                <div class="title must relative">发票类型</div>
                                <div class="flex-box pl30">
                                    <div class="type_item flex-box mr30 cursor" :class="tabIndex == 0 ? 'active' : ''"
                                        @click="tabIndex = 0, invoice.is_ordinary == 1">普票</div>
                                    <div class="type_item flex-box mr30 cursor" :class="tabIndex == 1 ? 'active' : ''"
                                        @click="tabIndex = 1, invoice.is_ordinary == 0">专票</div>

                                </div>
                            </div>
                            <div class="title must fs16 col04 relative mb15">企业名称</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入公司全称" v-model="invoice.invoice_heard"
                                :disabled="true">
                            <div class="title must fs16 col04 relative mb15">税号</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入15-20位数和字母"
                                v-model="invoice.invoice_pay_number" :disabled="true">
                            <div class="title fs16 col04 relative mb15">地址</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入地址"
                                v-model="invoice.invoice_address">
                            <div class="title fs16 col04 relative mb15">电话</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入电话" v-model="invoice.invoice_phone">
                            <div class="title fs16 col04 relative mb15">开户行</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入开户银行" v-model="invoice.invoice_bank">
                            <div class="title fs16 col04 relative mb15">银行卡号</div>
                            <input type="text" class="input fs16 mb25" placeholder="请输入银行卡号"
                                v-model="invoice.invoice_bank_card_number">
                            <div class="title fs16 col04 relative mb15">备注</div>
                            <input type="text" class="input fs16 mb25" placeholder="请填写备注" v-model="invoice.memo">
                            <div class="title must fs16 col04 relative mb15">电子邮箱</div>
                            <input type="text" class="input fs16 mb50" placeholder="请输入您的接收邮箱地址"
                                v-model="invoice.accept_email">
                            <div class="cursor sure fs16 colf flex-box flex-center" @click="next">确认</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-box choose_box">
                            <div class="fs18 col90 fwb flex-grow-1">选择发票抬头</div>
                            <div class="back fs18 col12 cursor flex-box" @click="showList = false">返回</div>
                            <div class="flex-box new colf flex-center cursor fs16 ml30" @click="newAddPop = true">新 增</div>
                            <div class="flex-box confirm colf flex-center cursor fs16 ml30" @click="showList = false">确 认
                            </div>
                        </div>
                        <template v-if="goodsList.length > 0">
                            <div class="list_box mt35">
                                <div class="title_box flex-box col04">
                                    <div class="box1 cursor"></div>
                                    <div class="box2 tc">企业名称</div>
                                    <div class="box3 tc">税号</div>
                                    <div class="flex-grow-1 tc">操作</div>
                                </div>
                                <div class="address_box flex-box col90" v-for="(item, index) in 10" :key="index">
                                    <div class="box1 cursor active"></div>
                                    <div class="box2 flex-box flex-center">
                                        <div>墨刀科技有限公司</div>
                                        <div class="default fs10 colf tc ml5">默认</div>
                                    </div>
                                    <div class="box3 tc">123456789012345678</div>
                                    <router-link class="flex-grow-1 tc cursor" to="TitleEdit">修改</router-link>
                                </div>
                            </div>
                        </template>
                        <div v-else class="nodata fs16 tc">
                            <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                            <div>您还没有添加发票抬头哦</div>
                        </div>
                        <pagination :sumCount="sumCount" :perCount="perCount" v-show="sumCount > perCount"></pagination>
                    </template>
                </template>
                <template v-if="step == 2">
                    <div class="choose_box fs18 col90 fwb">开具电子发票</div>
                    <div class="flex-box tips coleb fs16">温馨提示：请确认邮箱无误，电子发票将在系统开具后发送至您的邮箱，请注意查收。</div>
                    <div class="info_box fs16">
                        <div class="flex-box mb10">
                            <div class="title flex-box flex-between">
                                <span>发</span><span>票</span><span>类</span><span>型</span>
                            </div>
                            <div class="flex-grow-1 fwb">电子发票</div>
                        </div>
                        <div class="flex-box mb10">
                            <div class="title flex-box flex-between">
                                <span>发</span><span>票</span><span>抬</span><span>头</span>
                            </div>
                            <div class="flex-grow-1 fwb">{{ invoice.invoice_heard }}</div>
                        </div>
                        <div class="flex-box mb10">
                            <div class="title flex-box flex-between"><span>税</span><span>号</span></div>
                            <div class="flex-grow-1 fwb">{{ invoice.invoice_pay_number }}</div>
                        </div>
                        <div class="flex-box">
                            <div class="title flex-box flex-between">
                                <span>电</span><span>子</span><span>邮</span><span>箱</span>
                            </div>
                            <div class="flex-grow-1 fwb">{{ invoice.accept_email }}</div>
                        </div>
                        <div class="sure fs16 colf fwb cursor" @click="onSave">确认提交</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "发票管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            step: 1,
            showList: false,
            goodsList: [''],
            sumCount: 0,
            perCount: 0,
            tablist: [{ id: 1, name: "普票" }, { id: 0, name: "专票" }],
            tabIndex: 0,
            invoice: {
                is_company: 2,
                is_ordinary: 1,
                invoice_heard: '',
                invoice_pay_number: '',
                invoice_address: '',
                invoice_phone: '',
                invoice_bank: '',
                invoice_bank_card_number: '',
                memo: '',
                accept_email: ''
            },
            orderIds: '',
        };
    },
    created() {
        this.$api.getInstitutionTitle().then(res => {
            if (res.code == 1) {
                this.invoice.invoice_heard = res.data.company_name;
                this.invoice.invoice_pay_number = res.data.license_no
            }
        }).catch(err => {
            console.log(err)
        })
        this.orderIds = this.$route.query.ids;
    },
    methods: {
        // 确认发票抬头
        next() {
            if (this.invoice.invoice_heard == '') {
                this.$message({
                    customClass: 'custom-message',
                    message: '请填写企业名称',
                    type: 'error',
                    duration: 3000
                })
                return;
            }
            if (this.invoice.invoice_pay_number == '') {
                this.$message({
                    customClass: 'custom-message',
                    message: '请填写税号',
                    type: 'error',
                    duration: 3000
                })
                return;
            }
            if (this.invoice.accept_email == '') {
                this.$message({
                    customClass: 'custom-message',
                    message: '请填写邮箱',
                    type: 'error',
                    duration: 3000
                })
                return;
            }
            this.step = 2;
        },
        // 确认提交
        onSave() {
            let invoice = this.invoice;
            invoice.order_id = this.orderIds.toString();
            this.$api.addInvoice({
                ...invoice
            }).then(res => {
                this.$message({
                    customClass: 'custom-message',
                    message: '开票成功',
                    type: 'success',
                    duration: 3000
                })
                this.$router.push('/Invoice')
            }).catch(err => {
                this.$message({
                    customClass: 'custom-message',
                    message: err.msg,
                    type: 'error',
                    duration: 3000
                })
            })
        },
    },
};
</script>

<style lang="less" scoped>
.choose_box {
    margin-top: 44px;
}

.to_choose {
    font-weight: 600;
    font-size: 20px;
    color: #3D7EFE;
    text-decoration-line: underline;

    &::after {
        content: "";
        display: block;
        width: 15px;
        height: 15px;
        background: url('/src/assets/static/icon/c_continue.png') no-repeat center;
        background-size: 100%;
        margin-left: 6px;
    }
}

.back::before {
    content: "";
    display: block;
    width: 27px;
    height: 24px;
    background: url('/src/assets/static/icon/c_back.png') no-repeat center;
    background-size: 100%;
    margin-right: 10px;
}

.part_r {
    padding: 40px 44px 100px;
    background: #fff;

    .step_box {
        padding: 44px 0 55px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);

        i {
            width: 34px;
            height: 34px;
            background: #E6E6E6;
            border-radius: 50%;
            text-align: center;
            line-height: 34px;
            color: #fff;
            margin-right: 16px;
        }

        .flex-box {
            &::after {
                content: "";
                display: block;
                width: 90px;
                border: 1px dashed #D7D4D4;
                margin: 0 10px;
            }

            &:nth-of-type(3)::after {
                display: none;
            }

            &.active {
                color: #3D7EFE;

                i {
                    background: #FFD040;
                }

                &::after {
                    border: 1px dashed #3D7EFE;
                }
            }
        }

    }

    .form_box {
        padding: 54px 190px 0;

        .title.must::before {
            display: block;
            content: "";
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #EB3F25;
            position: absolute;
            left: -20px;
            top: -1px;
            bottom: 0;
            margin: auto;
        }

        .sure {
            width: 100%;
            height: 50px;
            border-radius: 8px;
            background: #3D7EFE;
        }

        .input {
            width: 100%;
            height: 50px;
            border-radius: 8px;
            border: 2px solid rgba(98, 134, 171, 0.2);
            padding: 0 24px;
        }

        .input::placeholder {
            color: #909090;
        }

        .type {
            padding-left: 66px;
        }

        .textarea {
            width: 100%;
            height: 134px;
            border-radius: 8px;
            border: 2px solid rgba(98, 134, 171, 0.2);
            padding: 18px 24px;
            resize: none;
        }

        .textarea::placeholder {
            color: #909090;
        }
    }

    .new {
        width: 108px;
        height: 44px;
        border-radius: 6px;
        background: #1275ff;

        &::before {
            display: block;
            content: "";
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 8px;
            background: url('/src/assets/static/icon/c_add_new.png') no-repeat center;
            background-size: 100%;
        }
    }

    .confirm {
        width: 108px;
        height: 44px;
        border-radius: 6px;
        background: #EB3F25;
    }

    .title_box {
        padding-left: 44px;
        height: 50px;
        background: #fafcff;
    }

    .address_box {
        padding-left: 44px;
        height: 68px;
        border-bottom: 1px solid #c0cfdd;
    }

    .box1 {
        width: 20px;
        height: 20px;
        background: url('/src/assets/static/icon/c_check.png') no-repeat center;
        background-size: 100%;

        &.active {
            background-image: url('/src/assets/static/icon/c_check-on.png');
        }
    }

    .box2 {
        width: 405px;
    }

    .box3 {
        width: 350px;
    }

    .default {
        width: 39px;
        height: 18px;
        line-height: 18px;
        border-radius: 4px;
        border: 0.5px solid #aad8fe;
        background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
    }

    .nodata {
        padding-top: 110px;
        height: 380px;
        color: #c9cdd4;

        .c_nodata {
            width: 263px;
            height: 166px;
            display: block;
            margin: 0 auto;
        }
    }
}

.tips {
    width: 100%;
    height: 48px;
    background: rgba(235, 63, 37, 0.06);
    border-radius: 8px;
    margin: 15px 0 30px;

    &::before {
        content: "";
        display: block;
        width: 18px;
        height: 18px;
        background: url('/src/assets/static/icon/c_wait.png') no-repeat center;
        background-size: 100%;
        margin: 0 17px 0 20px;
    }
}

.info_box {
    width: 598px;
    margin: 0 auto;
    color: #333;

    .flex-box {
        height: 55px;

        .flex-grow-1 {
            height: 55px;
            line-height: 55px;
            border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        }
    }

    .title {
        width: 76px;
        margin-right: 66px;
    }

    .sure {
        width: 100%;
        height: 50px;
        background: #3D7EFE;
        border-radius: 8px;
        text-align: center;
        line-height: 50px;
        margin-top: 44px;
    }
}

.type_item {
    &::before {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        background: url('/src/assets/static/icon/c_check2.png') no-repeat center;
        background-size: 100%;
        margin-right: 20px;
    }

    &.active::before {
        background-image: url('/src/assets/static/icon/c_check2-on.png');
    }
}
</style>
